export default {
  user: {},
  employers: [],
  rebid_documents: [],
  reability_status: 0,
};
